/* Cart drawer recommendations (snippets/bogo-cart-recs.liquid): "+ ADD FREE" / "+ ADD".
   Delegated on document, so it keeps working after the drawer re-renders. */
(() => {
  if (window.bogoCartRecs) return;
  window.bogoCartRecs = true;

  const drawer = () => document.querySelector('cart-drawer');

  const add = async (variantId, el) => {
    const d = drawer();
    const sections = d && d.getSectionsToRender ? d.getSectionsToRender().map((s) => s.section) : [];
    el.classList.add('is-loading');
    try {
      const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1, properties: { _bogo_pick: 'cart' } }],
          sections,
          sections_url: window.location.pathname,
        }),
      }).then((r) => r.json());
      if (res.status) throw new Error(res.description || res.message);
      if (d && res.sections) d.renderContents(res);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bogo-cart-recs', cartData: res });
      }
    } catch (e) {
      el.classList.remove('is-loading');
      console.error('bogo-cart-recs', e);
    }
  };

  const showSizes = (btn) => {
    const wrap = btn.closest('[data-bogo-cartrecs]');
    const box = wrap.querySelector('[data-bogo-cartrecs-sizes]');
    const row = box.querySelector('[data-bogo-cartrecs-size-row]');
    wrap.querySelectorAll('.bogo-card.is-on').forEach((c) => c.classList.remove('is-on'));
    btn.closest('.bogo-card').classList.add('is-on');
    box.querySelector('[data-bogo-cartrecs-size-name]').textContent = btn.dataset.name;
    row.innerHTML = '';
    btn.dataset.sizes.split('|').filter(Boolean).forEach((s) => {
      const [id, title] = s.split('~');
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'bogo-cartrecs__size';
      b.dataset.bogoCartrecsSize = id;
      b.textContent = title;
      row.appendChild(b);
    });
    box.hidden = false;
    box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  };

  document.addEventListener('click', (e) => {
    const size = e.target.closest('[data-bogo-cartrecs-size]');
    if (size) {
      e.preventDefault();
      add(size.dataset.bogoCartrecsSize, size.closest('[data-bogo-cartrecs]'));
      return;
    }
    const btn = e.target.closest('[data-bogo-cartrecs-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.dataset.sizes) showSizes(btn);
    else add(btn.dataset.variantId, btn.closest('[data-bogo-cartrecs]'));
  });

  // Safety net: the drawer drawn with the page shares the page's render (and its all_products budget). The first
  // time the drawer opens after a page load, fetch the block once in its own render via the Section Rendering API
  // and swap it in. After any cart change the drawer is already re-rendered on its own (cart.js), so once is enough.
  // Nothing is shown while loading; an identical block is left untouched (no layout shift).
  let refreshed = false;
  let cartVersion = 0;
  // A cart change re-renders the drawer on its own: then this refresh is not needed (any more)
  ['cart-drawer-refreshed', 'cart-updated'].forEach((ev) => document.addEventListener(ev, () => { cartVersion += 1; refreshed = true; }));

  const refreshRecs = async () => {
    const d = drawer();
    const main = d && d.querySelector('.cart-drawer__main');
    if (!main) return; // empty cart: no block
    const started = cartVersion;
    try {
      const url = `${window.location.pathname}?sections=cart-drawer`;
      const html = (await fetch(url, { headers: { Accept: 'application/json' } }).then((r) => r.json()))['cart-drawer'];
      if (!html || cartVersion !== started) return; // the drawer was re-rendered meanwhile: that one is fresh
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-bogo-cartrecs]');
      const current = main.querySelector('[data-bogo-cartrecs]');
      if (current && fresh && current.innerHTML === fresh.innerHTML) return;
      if (current) current.remove();
      if (fresh) {
        const items = main.querySelector('cart-drawer-items');
        if (items) items.after(fresh); else main.appendChild(fresh);
      }
    } catch (e) {
      console.error('bogo-cart-recs refresh', e);
    }
  };

  const watchDrawer = () => {
    const d = drawer();
    if (!d) return;
    new MutationObserver(() => {
      if (refreshed || !d.classList.contains('is-visible')) return;
      refreshed = true;
      refreshRecs();
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer);
  else watchDrawer();
})();
